import script from "./InformationTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./InformationTooltip.vue?vue&type=style&index=0&id=894e96f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-894e96f8"]])

export default __exports__